export const mockUserWithTokenExpireTime = {
  createdOn: "2022-07-21T08:01:45Z",
  modifiedOn: "2022-07-21T08:01:45Z",
  expirationTime: "2022-07-22T08:01:45Z",
  preferredUsername: "foo.bar@valuemotive.com",
  username: "foobarfoobar",
  permissions: null,
};
